export default "https://cdn-static.gokick.com/assets/672a5c69b0b224f66a9a6ac0576938eca42c1cee/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";